module.exports = __webpack_public_path__ + "img/mobile-creative-title-01.eb5c3ac3.svg";